import { PageHero } from "@/components/PageHero";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { ProcessSteps } from "@/components/ProcessSteps";
import { Marquee } from "@/components/Marquee";
import { QuoteCTA } from "@/components/QuoteCTA";
import { siteConfig } from "@/data/siteConfig";

const pillars = [
  { title: "Multi-Brand Parts Focus", desc: "Aftermarket parts across agricultural tractors, implements, backhoe loaders and 3-point linkage components — not a broad, unfocused catalogue." },
  { title: "Reliability Philosophy", desc: "We position ourselves around dependable, durable components and a straightforward enquiry process." },
  { title: "International Orientation", desc: "Built on Ocean Exports' export-oriented outlook and experience serving customers internationally." },
];

const brands = ["Massey Ferguson", "Ford", "New Holland", "John Deere", "Sonalika", "Mahindra", "Case", "JCB"];

export default function About() {
  return (
    <>
      <PageHero kicker="About" title="About Ocean Exports"
        text={`${siteConfig.company.name}. ${siteConfig.company.division}`}
        image="https://images.unsplash.com/photo-1610259998914-d1b9afe0dc55?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" />

      <section className="bg-white py-20 lg:py-28">
        <div className="mx-auto grid max-w-7xl items-start gap-12 px-4 sm:px-6 lg:grid-cols-2">
          <SectionHeading kicker="Positioning" title="Built Around Dependable Multi-Brand Sourcing"
            text="Ocean Exports is positioned as a supplier of aftermarket parts for agricultural tractors — including Massey Ferguson, Ford, New Holland, John Deere, Sonalika and Mahindra — agricultural implements, and Case & JCB backhoe loaders, with 3-point linkage parts as our core strength." />
          <Reveal className="space-y-6">
            {pillars.map((p) => (
              <div key={p.title} className="border-l-2 border-amber bg-canvas p-6">
                <h3 className="font-display uppercase text-xl tracking-wide text-ink">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted">{p.desc}</p>
              </div>
            ))}
            <p className="text-sm leading-relaxed text-muted">{siteConfig.company.divisionNote}</p>
          </Reveal>
        </div>
      </section>

      <Marquee items={["Durability", "Precision", "Export Heritage", "Tractor & Implement Parts", "B2B Supply"]} />

      <section className="bg-canvas py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <SectionHeading kicker="Our Divisions" title="Terramech Components Inc. & LAV-TEK — Divisions of Ocean Exports"
            text="Terramech Components Inc. and LAV-TEK operate as specialised parts divisions under Ocean Exports, extending our supply of tractor, implement and backhoe loader components." />
        </div>
      </section>

      <section className="bg-white py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <SectionHeading kicker="Brands We Support" title="Multi-Brand Aftermarket Coverage"
            text="We supply aftermarket parts across the following tractor and backhoe loader brands." />
          <div className="mt-12 flex flex-wrap gap-3" data-testid="brands-grid">
            {brands.map((b, i) => (
              <Reveal key={b} delay={i * 0.05} as="span" className="border border-[#E3E8EF] bg-canvas px-5 py-3 font-display uppercase text-sm tracking-wide text-ink" data-testid={`brand-${b.toLowerCase().replace(/\s+/g, "-")}`}>
                {b}
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-canvas py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <SectionHeading kicker="How We Work" title="A Clearer Way to Source Replacement Parts" />
          <div className="mt-12"><ProcessSteps /></div>
        </div>
      </section>

      <QuoteCTA />
    </>
  );
}
